import React, { Component } from 'react'
import '../styles/OrganizationCapitalization.css'
import OrgFooter from '../widgets/OrgFooter'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import TickBoxWidget from '../widgets/TickBoxWidget'
import DatePicker from '../widgets/DatePicker'

class OrganizationCapitalization extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			dateToday: sessionStorage.getItem("date-today"),
			arboId: sessionStorage.getItem("arbo-id"),
			scrollable: false,
			geItemObj: {},
			geKeyTracer: 0,
			geListItems: [],
			leItemObj: {},
			leKeyTracer: 0,
			leListItems: [],
			fundSourceGrant: {},
			deleteFundSourceGrant: {},
			fundSourceLoan: {},
			deleteFundSourceLoan: {},
			shouldDisplayValues: props.displayValues,
			isViewDetails: props.isViewDetails,
			paidCBU: "0",
			withSavings: "0",
			savings: "0.00",
			cbu: "0.00",
			externalFundIsOn: true,
			internalFundIsOn: false,
			tbDefault: []
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.geEventHandler = this.geEventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.leEventHandler = this.leEventHandler.bind(this)
		this.setGrantSourceListItems = this.setGrantSourceListItems.bind(this)
		this.setLoanSourceListItems = this.setLoanSourceListItems.bind(this)
		this.setFundSourceInternal = this.setFundSourceInternal.bind(this)
		this.setSOFView = this.setSOFView.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const fundSourceGrant = []
		const addFundSourceGrant = []
		Object.values(this.state.fundSourceGrant).forEach((v) => {
			if(v.id != null) {
				fundSourceGrant.push(v)
			}
			else {
				addFundSourceGrant.push(v)
			}
		})
		const deleteFundSourceGrant = []
		Object.values(this.state.deleteFundSourceGrant).forEach((v) => {
			deleteFundSourceGrant.push(v)
		})
		const fundSourceLoan = []
		const addFundSourceLoan = []
		Object.values(this.state.fundSourceLoan).forEach((v) => {
			if(v.id != null) {
				fundSourceLoan.push(v)
			}
			else {
				addFundSourceLoan.push(v)
			}
		})
		const deleteFundSourceLoan = []
		Object.values(this.state.deleteFundSourceLoan).forEach((v) => {
			deleteFundSourceLoan.push(v)
		})
		const data = {}
		if(this.state.externalFundIsOn) {
			data["fundSourceGrant"] = fundSourceGrant
			data["fundSourceLoan"] = fundSourceLoan
		}
		if(addFundSourceGrant.length > 0 || addFundSourceLoan.length > 0) {
			data["add"] = {
				fundSourceGrant: addFundSourceGrant,
				fundSourceLoan: addFundSourceLoan,
			}
		}
		if(deleteFundSourceGrant.length > 0 || deleteFundSourceLoan.length > 0) {
			data["delete"] = {
				fundSourceGrant: deleteFundSourceGrant,
				fundSourceLoan: deleteFundSourceLoan,
			}
		}
		if(this.state.internalFundIsOn) {
			data["fundSourceInternal"] = {
				cbu: this.state.cbu,
				no_of_members_with_paid_cbu: this.state.paidCBU,
				savings: this.state.savings,
				no_of_members_with_savings: this.state.withSavings
			}
		}
		if(data.add == null && data.delete == null && fundSourceGrant.length < 1 && fundSourceLoan.length < 1) {
			const apiReq = APIOrganizationRequest.addFinanceByArboId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					fundSourceGrant: {},
					fundSourceLoan: {}
				})
			})
		}
		else {
			const apiReq = APIOrganizationRequest.editFinanceByArboId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false,
					fundSourceGrant: {},
					fundSourceLoan: {}
				})
			})
		}
	}

	componentDidMount() {
		this.setState({showActivityIndicator: true})
		const obi = APIOrganizationRequest.getFarmerOrgById(this.state.accessToken, this.state.arboId)
		obi.then((response) => {
			this.setState({
				orgName: response.results.name,
				partnershipType: response.results.category,
				province: response.results.province,
				city: response.results.city,
				arcName: response.results.arc_name,
				partnershipDate: response.results.partnership_date
			})
			const cm = APIOrganizationRequest.getFinanceByArboId(this.state.accessToken, this.state.arboId)
			cm.then((response) => {
				if(response.status === "ERROR") {
					this.setState({showActivityIndicator: false})
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description,
						showActivityIndicator: false
					})
					return
				}
				this.setGrantSourceListItems(response.results.fundSourceGrant)
				this.setLoanSourceListItems(response.results.fundSourceLoan)
				this.setFundSourceInternal(response.results.fundSourceInternal)
				this.setScrollable()
			})
		})
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	setGrantSourceListItems(fundSourceGrant) {
		const grants = []
		let externalFundIsOn = false
		if(fundSourceGrant != null) {
			externalFundIsOn = true
			this.setTickBoxDefault(0)
			for(const v of fundSourceGrant) {
				const geKey = "ge-" + this.state.geKeyTracer
				this.state.geItemObj[geKey] = <GrantExternalFund data={v} handler={this.geEventHandler}
					disabled={this.state.isViewDetails} key={geKey} id={geKey} />
				this.state.geKeyTracer++
			}
			const geKey = "ge-" + this.state.geKeyTracer
			this.state.geItemObj[geKey] = <GrantExternalFund handler={this.geEventHandler}
				disabled={this.state.isViewDetails} key={geKey} id={geKey} />
			this.state.geKeyTracer++
			Object.keys(this.state.geItemObj).forEach((k => {
				grants.push(this.state.geItemObj[k])
			}))
		}
		else {
			const geKey = "ge-" + this.state.geKeyTracer
			this.state.geItemObj[geKey] = <GrantExternalFund handler={this.geEventHandler} key={geKey} id={geKey} />
			this.state.geKeyTracer++
			grants.push(this.state.geItemObj[geKey])
		}
		this.setState({geListItems: grants, externalFundIsOn: externalFundIsOn})
	}

	setLoanSourceListItems(fundSourceLoan) {
		const loans = []
		let externalFundIsOn = false
		if(fundSourceLoan != null) {
			externalFundIsOn = true
			this.setTickBoxDefault(0)
			for(const v of fundSourceLoan) {
				const leKey = "le-" + this.state.leKeyTracer
				this.state.leItemObj[leKey] = <LoanExternalFund data={v} handler={this.leEventHandler}
					disabled={this.state.isViewDetails} key={leKey} id={leKey} />
				this.state.leKeyTracer++
			}
			const leKey = "le-" + this.state.leKeyTracer
			this.state.leItemObj[leKey] = <LoanExternalFund handler={this.leEventHandler}
				disabled={this.state.isViewDetails} key={leKey} id={leKey} />
			this.state.leKeyTracer++
			Object.keys(this.state.leItemObj).forEach((k => {
				loans.push(this.state.leItemObj[k])
			}))
		}
		else {
			const leKey = "le-" + this.state.leKeyTracer
			this.state.leItemObj[leKey] = <LoanExternalFund handler={this.leEventHandler} key={leKey} id={leKey} />
			this.state.leKeyTracer++
			loans.push(this.state.leItemObj[leKey])
		}
		this.setState({
			leListItems: loans,
			showActivityIndicator: false,
			externalFundIsOn: externalFundIsOn
		})
	}

	setTickBoxDefault(v) {
		const tbDefault = []
		if(!this.state.tbDefault.includes(v)) {
			tbDefault.push(v)
			for(const i of this.state.tbDefault) {
				tbDefault.push(i)
			}
			this.setSOFView(tbDefault)
			this.setState({tbDefault: tbDefault})
		}
	}

	setSOFView(options) {
		if(options[0] != null && options[1] == null) {
			document.getElementById('of-cell2').style.display = 'block'
			document.getElementById('of-cell3').style.display = 'block'
			document.getElementById('of-cell5').style.display = 'none'
			var externalFundIsOn = true
			var internalFundIsOn = false
		}
		else if(options[1] != null && options[0] == null) {
			document.getElementById('of-cell2').style.display = 'none'
			document.getElementById('of-cell3').style.display = 'none'
			document.getElementById('of-cell5').style.display = 'flex'
			externalFundIsOn = false
			internalFundIsOn = true
		}
		else if(options[0] != null && options[1] != null) {
			document.getElementById('of-cell2').style.display = 'block'
			document.getElementById('of-cell3').style.display = 'block'
			document.getElementById('of-cell5').style.display = 'flex'
			externalFundIsOn = true
			internalFundIsOn = true
		}
		else {
			document.getElementById('of-cell2').style.display = 'none'
			document.getElementById('of-cell3').style.display = 'none'
			document.getElementById('of-cell5').style.display = 'none'
			externalFundIsOn = false
			internalFundIsOn = false
		}
		this.setState({
			externalFundIsOn: externalFundIsOn,
			internalFundIsOn: internalFundIsOn
		})
	}

	setFundSourceInternal(fundSourceInternal) {
		if(fundSourceInternal == null) {
			return
		}
		this.setState({
			cbu: fundSourceInternal.cbu,
			paidCBU: fundSourceInternal.no_of_members_with_paid_cbu,
			savings: fundSourceInternal.savings,
			withSavings: fundSourceInternal.no_of_members_with_savings,
			internalFundIsOn: true
		})
		this.setTickBoxDefault(1)
	}

	geEventHandler(e, compId, key, value) {
		switch(e) {
			case "external-grant":
				this.state.fundSourceGrant[compId] = value
				break
			case "add":
				this.state.fundSourceGrant[compId] = value
				const added = []
				const geKey = "ge-" + this.state.geKeyTracer
				this.state.geItemObj[geKey] = <GrantExternalFund handler={this.geEventHandler} key={geKey} id={geKey} />
				this.state.geKeyTracer++
				this.state.geListItems.push(this.state.geItemObj[geKey])
				Object.keys(this.state.geItemObj).forEach((k => {
					added.push(this.state.geItemObj[k])
				}))
				this.setState({geListItems: added})
				break
			case "delete":
				this.state.deleteFundSourceGrant[compId] = value
				delete this.state.geItemObj[compId]
				const deleted = []
				Object.keys(this.state.geItemObj).forEach((k => {
					deleted.push(this.state.geItemObj[k])
				}))
				this.setState({geListItems: deleted})
		}
		this.setScrollable()
	}

	leEventHandler(e, compId, key, value) {
		switch(e) {
			case "external-loan":
				this.state.fundSourceLoan[compId] = value
				break
			case "add":
				this.state.fundSourceLoan[compId] = value
				const added = []
				const leKey = "le-" + this.state.leKeyTracer
				this.state.leItemObj[leKey] = <LoanExternalFund handler={this.leEventHandler} key={leKey} id={leKey} />
				this.state.leKeyTracer++
				this.state.leListItems.push(this.state.leItemObj[leKey])
				Object.keys(this.state.leItemObj).forEach((k => {
					added.push(this.state.leItemObj[k])
				}))
				this.setState({leListItems: added})
				break
			case "delete":
				this.state.deleteFundSourceLoan[compId] = value
				delete this.state.leItemObj[compId]
				const deleted = []
				Object.keys(this.state.leItemObj).forEach((k => {
					deleted.push(this.state.leItemObj[k])
				}))
				this.setState({leListItems: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('of-scroll-area')
		const ca = document.getElementById('of-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+75) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const rbOptions = ["External Fund", "Internal Fund"]
		const view = <div id="org-finance">
			<div id="of-scroll-area"><div id="of-client-area">
				<div id="of-cell1">
					<div id="of-cell1-r1">
						<div id="of-cell1-r1-i1">
							<div>Organization Name</div>
							<input type="text" value={this.state.orgName} disabled="true" />
						</div>
						<div id="of-cell1-r1-i2">
							<div>Type</div>
							<input type="text" value={this.state.partnershipType} disabled="true" />
						</div>
					</div>
					<div id="of-cell1-r2">
						<div id="of-cell1-r2-i1">
							<div>Province</div>
							<input type="text" value={this.state.province} disabled="true" />
						</div>
						<div id="of-cell1-r2-i2">
							<div>Municipality</div>
							<input type="text" value={this.state.city} disabled="true" />
						</div>
						<div id="of-cell1-r2-i3">
							<div>Name of Agrarian Reform Community</div>
							<input type="text" value={this.state.arcName} disabled="true" />
						</div>
					</div>
				</div>
				<div className="title-bar">ARBO FINANCIAL DETAILS</div>
				<div id="of-cell4">
					<div>Source of Funds:</div>
					<TickBoxWidget
						name={this.state.itemId}
						options={rbOptions}
						direction="row"
						default={this.state.tbDefault}
						optionSelected={(value) => {
							this.setSOFView(value.options)
							this.setScrollable()
						}} disabled={this.state.isViewDetails} />
				</div>
				<div id="of-cell2">
					<div style={{'flex-basis': '100%'}}>EXTERNAL FUND - GRANT</div>
					<table className="ge-table-header">
						<col style={{width: '50%'}} />
						<col style={{width: '25%'}} />
						<col style={{width: '25%'}} />
						<tr>
							<th>Name of Source</th>
							<th>Grant Amount (Php)</th>
							<th>Date of Release</th>
						</tr>
					</table>
					{this.state.geListItems}
				</div>
				<div id="of-cell3">
					<div style={{'flex-basis': '100%'}}>EXTERNAL FUND - LOAN</div>
					<table className="le-table-header">
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<tr>
							<th>Type of Loan</th>
							<th>Source of Fund</th>
							<th>Loan Amount (Php)</th>
							<th>Date of Release</th>
							<th>Loan Status</th>
						</tr>
					</table>
					{this.state.leListItems}
				</div>
				<div id="of-cell5">
					<div style={{'flex-basis': '100%'}}>INTERNAL FUND</div>
					<div id="osa-cell4-i1">
						<div>CBU / Annual Dues</div>
						<input type="text" value={this.state.cbu} onChange={(e) => {
							if(isCurrencyValid(e.target.value)) {
								const v = e.target.value.replace(/,/g, "")
								this.setState({cbu: v})
								e.target.value = formatCurrency(e.target.value)
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = ""
								}
								else {
									const v = e.target.value.replace(/,/g, "")
									e.target.value = parseInt(v)
									e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
								}
							}
						}} disabled={this.state.isViewDetails} />
					</div>
					<div id="osa-cell4-i2">
						<div>No. of Member with Fully Paid CBU</div>
						<input type="text" value={this.state.paidCBU} onChange={(e) => {
							const checker = /^[0-9]+$/
							const isValid = checker.test(e.target.value)
							if(isValid) {
								this.setState({paidCBU: e.target.value})
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = ""
								}
								else {
									e.target.value = parseInt(e.target.value)
								}
							}
						}} disabled={this.state.isViewDetails} />
					</div>
					<div id="osa-cell4-i3">
						<div>Savings</div>
						<input type="text" value={this.state.savings} onChange={(e) => {
							if(isCurrencyValid(e.target.value)) {
								const v = e.target.value.replace(/,/g, "")
								this.setState({savings: v})
								e.target.value = formatCurrency(e.target.value)
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = ""
								}
								else {
									const v = e.target.value.replace(/,/g, "")
									e.target.value = parseInt(v)
									e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
								}
							}
						}} disabled={this.state.isViewDetails} />
					</div>
					<div id="osa-cell4-i4">
						<div>No. of Member with Savings</div>
						<input type="text" value={this.state.withSavings} onChange={(e) => {
							const checker = /^[0-9]+$/
							const isValid = checker.test(e.target.value)
							if(isValid) {
								this.setState({withSavings: e.target.value})
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = ""
								}
								else {
									e.target.value = parseInt(e.target.value)
								}
							}
						}} disabled={this.state.isViewDetails} />
					</div>
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
					<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class GrantExternalFund extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			fundSourceGrant: {},
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const fundSource = APIOrganizationRequest.getAllFundSources(this.state.accessToken)
		fundSource.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.fund_source_id, name: v.name})
			}
			this.setState({fundSources: c})
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.fundSourceGrant["id"] = this.props.data.id
			const amount = this.props.data.grant_amount + ""
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				name: this.props.data.source,
				grantAmount: amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
				dateReleased: this.props.data.date_released,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.fundSourceGrant)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// this.props.handler("delete", this.state.itemId, null, this.state.fundSourceGrant)
		const sl = this.state.fundSourceGrant.source? this.state.fundSourceGrant.source: this.state.name
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove external fund ${sl}?`
		})
	}

	render() {
		const view = <div className="grant-external">
			<div>{this.state.addDeleteButton}</div>
			<table className="ge-table-data">
				<col style={{width: '50%'}} />
				<col style={{width: '25%'}} />
				<col style={{width: '25%'}} />
				<tr>
					<td><input type="text" value={this.state.name} onChange={(e) => {
							this.state.fundSourceGrant["source"] = e.target.value
							this.props.handler("external-grant", this.state.itemId, null, this.state.fundSourceGrant)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({name: e.target.value})
						}} disabled={this.state.disabled} />
					</td>
					<td><input type="text" value={this.state.grantAmount} placeholder='0.00' onChange={(e) => {
						if(isCurrencyValid(e.target.value)) {
							const v = e.target.value.replace(/,/g, "")
							this.state.fundSourceGrant["grant_amount"] = v
							this.props.handler("external-grant", this.state.itemId, null, this.state.fundSourceGrant)
							e.target.value = formatCurrency(e.target.value)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({grantAmount: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({grantAmount: ''})
							}
							else {
								const v = e.target.value.replace(/,/g, "")
								e.target.value = parseInt(v)
								e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
							}
						}
					}} style={{'text-align': 'right'}} disabled={this.state.disabled} /></td>
					<td><DatePicker value={this.state.dateReleased} onChange={(value) => {
						this.state.fundSourceGrant["date_released"] = value
						this.props.handler("external-grant", this.state.itemId, null, this.state.fundSourceGrant)
						this.setState({dateReleased: value})
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} disabled={this.state.disabled} /></td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.fundSourceGrant)
					}
			}} />}
		</div>
		return(view)
	}
}

class LoanExternalFund extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			fundSourceLoan: {},
			loanType: "-- SELECT --",
			loanStatus: "-- SELECT --",
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getLoanTypes = this.getLoanTypes.bind(this)
		this.getLoanStatuses = this.getLoanStatuses.bind(this)
	}

	componentWillMount() {
		this.getLoanTypes()
		this.getLoanStatuses()
	}

	getLoanTypes() {
		const types = APIOrganizationRequest.getAllLoanTypes(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.loan_type_id, name: v.name})
			}
			this.setState({loanTypes: c})
		})
	}

	getLoanStatuses() {
		const status = APIOrganizationRequest.getAllLoanStatuses(this.state.accessToken)
		status.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.loan_status_id, name: v.name})
			}
			this.setState({loanStatuses: c})
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.fundSourceLoan["id"] = this.props.data.id
			const amount = this.props.data.loan_amount + ""
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				loanType: this.props.data.loan_type,
				financialInstitution: this.props.data.financial_institution,
				loanAmount: amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
				dateReleased: this.props.data.date_released,
				loanStatus: this.props.data.loan_status,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.fundSourceLoan)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// this.props.handler("delete", this.state.itemId, null, this.state.fundSourceLoan)
		const sl = this.state.fundSourceLoan.financial_institution? this.state.fundSourceLoan.financial_institution: this.state.financialInstitution
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove external fund ${sl}?`
		})
	}

	render() {
		const view = <div className="loan-external">
			<div>{this.state.addDeleteButton}</div>
			<table className="le-table-data">
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<tr>
					<td><DropdownWidget list={this.state.loanTypes} placeholder={this.state.loanType} cStyle={{'width': 'calc(100% - 5px)'}}
						onItemSelected={(id, val) => {
							this.state.fundSourceLoan["loan_type_id"] = id
							this.props.handler("external-loan", this.state.itemId, null, this.state.fundSourceLoan)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
					<td><input type="text" value={this.state.financialInstitution} onChange={(e) =>{
						this.state.fundSourceLoan["financial_institution"] = e.target.value
						this.props.handler("external-loan", this.state.itemId, null, this.state.fundSourceLoan)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.setState({financialInstitution: e.target.value})
					}} disabled={this.state.disabled} /></td>
					<td><input type="text" value={this.state.loanAmount}  placeholder="0.00" onChange={(e) =>{
						if(isCurrencyValid(e.target.value)) {
							const v = e.target.value.replace(/,/g, "")
							this.state.fundSourceLoan["loan_amount"] = v
							this.props.handler("external-loan", this.state.itemId, null, this.state.fundSourceLoan)
							e.target.value = formatCurrency(e.target.value)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({loanAmount: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({loanAmount: ''})
							}
							else {
								const v = e.target.value.replace(/,/g, "")
								e.target.value = parseInt(v)
								e.target.value = e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
							}
						}
					}} style={{'text-align': 'right'}} disabled={this.state.disabled} /></td>
					<td><DatePicker value={this.state.dateReleased} onChange={(value) => {
						this.state.fundSourceLoan["date_released"] =value
						this.props.handler("external-loan", this.state.itemId, null, this.state.fundSourceLoan)
						this.setState({dateReleased: value})
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}} disabled={this.state.disabled} /></td>
					<td><DropdownWidget list={this.state.loanStatuses} placeholder={this.state.loanStatus} cStyle={{'width': '100%'}}
						onItemSelected={(id, val) => {
						this.state.fundSourceLoan["loan_status_id"] = id
						this.props.handler("external-loan", this.state.itemId, null, this.state.fundSourceLoan)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.fundSourceLoan)
					}
			}} />}
		</div>
		return(view)
	}
}

const formatCurrency = (value) => {
	const v = value.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const isCurrencyValid = (value) => {
	const checker = /^[\d,]+\.?\d{0,2}?$/
	const isValid = checker.test(value)
	return(isValid)
}

export default OrganizationCapitalization
